import script from "./Invisalign.vue?vue&type=script&setup=true&lang=ts"
export * from "./Invisalign.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__